class Candidate {
    constructor(name,lastname, phone, email, curp, nss, address, position, state, city, client) {
        this.name = name
        this.lastname = lastname
        this.phone = phone
        this.email = email
        this.curp = curp
        this.nss = nss
        this.address = address
        this.position = position
        this.state = state
        this.city = city
        this.client = client
    }
}

export default Candidate